import { createApp } from "vue";
import App from "./App.vue";
import i18n from "./lang/index";
import router from './router';
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

// import "@/assets/css/common/normalize.css";
// import "@/assets/css/common/animate.css";
// import "@/assets/css/common/swiper8-bundle.min.css";
// import "@/assets/css/coc-en/pay-center/main.css";
// import "@/assets/js/country-config";

const app = createApp(App);

app.use(i18n);
app.use(router);

app.mount("#app");